import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { MessageService } from 'primeng/api';
import {
  ComplaintApiService,
  ComplaintResponseDTO,
  ManualExecutionResponse,
  ProgressEventDTO,
} from '../../services/complaint-api.service';

@Component({
  selector: 'app-complaint-import',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    ProgressBarModule,
    ToolbarModule,
    ToastModule,
    TagModule,
    DividerModule,
  ],
  providers: [MessageService],
  template: `
    <!-- Toast para notificações -->
    <p-toast></p-toast>

    <!-- Painel: Importação por faixa de IDs -->
    <p-card>
      <ng-template pTemplate="header">
        <p-toolbar>
          <ng-template pTemplate="start">
            <h2>Importação por Faixa de IDs</h2>
          </ng-template>
        </p-toolbar>
      </ng-template>

      <ng-template pTemplate="content">
        <div class="import-form">
          <div class="form-row">
            <div class="field">
              <label for="idInicial">ID Inicial</label>
              <p-inputNumber
                inputId="idInicial"
                [(ngModel)]="idRange.idInicial"
                [min]="1"
                [useGrouping]="false"
                placeholder="Ex: 1"
                [disabled]="running.byRange"
                class="w-full">
              </p-inputNumber>
            </div>

            <div class="field">
              <label for="idFinal">ID Final</label>
              <p-inputNumber
                inputId="idFinal"
                [(ngModel)]="idRange.idFinal"
                [min]="1"
                [useGrouping]="false"
                placeholder="Ex: 100"
                [disabled]="running.byRange"
                class="w-full">
              </p-inputNumber>
            </div>

            <div class="field field-action">
              <p-button
                *ngIf="!running.byRange"
                label="Iniciar Importação"
                icon="pi pi-play"
                (onClick)="startRangeImport()"
                [disabled]="!canStartRange()"
                severity="primary">
              </p-button>

              <p-button
                *ngIf="running.byRange"
                label="Cancelar"
                icon="pi pi-times"
                (onClick)="cancelRangeImport()"
                severity="danger"
                [outlined]="true">
              </p-button>
            </div>
          </div>
        </div>

        <!-- Barra de progresso da importação por faixa -->
        <div *ngIf="running.byRange || rangeResult" class="progress-section mt-4">
          <p-divider></p-divider>

          <div class="progress-header">
            <div class="progress-info">
              <span class="progress-label">
                {{ rangeStatusLabel }}
              </span>
              <span class="progress-sub" *ngIf="rangeProgress">
                Processando ID {{ rangeProgress.currentId }} &middot;
                Processados: {{ rangeProgress.processed }}/{{ rangeProgress.total }}
              </span>
            </div>
            <p-tag
              [value]="rangeTagLabel"
              [severity]="rangeTagSeverity">
            </p-tag>
          </div>

          <p-progressBar
            [value]="rangePercentage"
            [showValue]="true"
            unit="%"
            [mode]="rangeProgressMode"
            [style]="{ height: '20px' }">
          </p-progressBar>

          <!-- Detalhes adicionais -->
          <div *ngIf="rangeProgress" class="progress-details mt-2">
            <div class="detail-item">
              <span class="detail-label">Faixa</span>
              <span class="detail-value">ID {{ rangeProgress.idInicial }} – {{ rangeProgress.idFinal }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Salvos</span>
              <span class="detail-value">{{ rangeProgress.savedCount }} registro(s)</span>
            </div>
            <div class="detail-item" *ngIf="rangeProgress.message">
              <span class="detail-label">Última mensagem</span>
              <span class="detail-value">{{ rangeProgress.message }}</span>
            </div>
          </div>
        </div>
      </ng-template>
    </p-card>

    <!-- Painel: Importação por Data (com progresso) -->
 <!--    <p-card class="mt-3">
      <ng-template pTemplate="header">
        <p-toolbar>
          <ng-template pTemplate="start">
            <h2>Importação por Data</h2>
          </ng-template>
        </p-toolbar>
      </ng-template>

      <ng-template pTemplate="content">
        <div class="import-form">
          <div class="form-row">
            <div class="field">
              <label for="dateInput">Data (AAAA-MM-DD)</label>
              <input
                id="dateInput"
                pInputText
                type="date"
                [(ngModel)]="dateSearch.date"
                [disabled]="dateImportRunning"
                class="w-full" />
            </div>

            <div class="field field-action">
              <p-button
                *ngIf="!dateImportRunning"
                label="Iniciar Importação"
                icon="pi pi-play"
                (onClick)="startDateImport()"
                [disabled]="!dateSearch.date"
                severity="primary">
              </p-button>
              <p-button
                *ngIf="dateImportRunning"
                label="Cancelar"
                icon="pi pi-times"
                (onClick)="cancelDateImport()"
                severity="danger"
                [outlined]="true">
              </p-button>
            </div>
          </div>
        </div>

         Barra de progresso da importação por data 
        <div *ngIf="dateImportRunning || dateProgress" class="progress-section mt-4">
          <p-divider></p-divider>
          <div class="progress-header">
            <div class="progress-info">
              <span class="progress-label">{{ dateImportRunning ? 'Processando data...' : dateProgress?.status === 'COMPLETED' ? 'Importação concluída!' : 'Importação interrompida.' }}</span>
              <span class="progress-sub" *ngIf="dateProgress">ID {{ dateProgress.currentId }} &middot; {{ dateProgress.processed }}/{{ dateProgress.total }}</span>
            </div>
            <p-tag [value]="dateProgress?.status ?? 'INICIANDO'" [severity]="dateProgress?.status === 'COMPLETED' ? 'success' : dateProgress?.status === 'FAILED' ? 'danger' : 'info'"></p-tag>
          </div>
          <p-progressBar [value]="datePercentage" [showValue]="true" unit="%" [mode]="dateProgressMode" [style]="{ height: '20px' }"></p-progressBar>
          <div *ngIf="dateProgress" class="progress-details mt-2">
            <div class="detail-item"><span class="detail-label">Salvos</span><span class="detail-value">{{ dateProgress.savedCount }} registro(s)</span></div>
            <div class="detail-item" *ngIf="dateProgress.message"><span class="detail-label">Última mensagem</span><span class="detail-value">{{ dateProgress.message }}</span></div>
          </div>
        </div>
      </ng-template>
    </p-card> -->

    <!-- Painel: Importação por Intervalo de Datas -->
    <p-card class="mt-3">
      <ng-template pTemplate="header">
        <p-toolbar>
          <ng-template pTemplate="start">
            <h2>Importação por Intervalo de Datas</h2>
          </ng-template>
        </p-toolbar>
      </ng-template>

      <ng-template pTemplate="content">
        <div class="import-form">
          <div class="form-row">
            <div class="field">
              <label for="dateRangeStart">Data Inicial</label>
              <input id="dateRangeStart" pInputText type="date" [(ngModel)]="dateRangeStart" [disabled]="dateRangeRunning" class="w-full" />
            </div>
            <div class="field">
              <label for="dateRangeEnd">Data Final</label>
              <input id="dateRangeEnd" pInputText type="date" [(ngModel)]="dateRangeEnd" [disabled]="dateRangeRunning" class="w-full" />
            </div>
            <div class="field field-action">
              <p-button *ngIf="!dateRangeRunning" label="Iniciar Importação" icon="pi pi-play" (onClick)="startDateRangeImport()" [disabled]="!canStartDateRange()" severity="primary"></p-button>
              <p-button *ngIf="dateRangeRunning" label="Cancelar" icon="pi pi-times" (onClick)="cancelDateRangeImport()" severity="danger" [outlined]="true"></p-button>
            </div>
          </div>
        </div>

        <!-- Barra de progresso da importação por intervalo de datas -->
        <div *ngIf="dateRangeRunning || dateRangeProgress" class="progress-section mt-4">
          <p-divider></p-divider>
          <div class="progress-header">
            <div class="progress-info">
              <span class="progress-label">{{ dateRangeRunning ? 'Processando intervalo...' : dateRangeProgress?.status === 'COMPLETED' ? 'Importação concluída!' : 'Importação interrompida.' }}</span>
              <span class="progress-sub" *ngIf="dateRangeProgress">ID {{ dateRangeProgress.currentId }} &middot; {{ dateRangeProgress.processed }}/{{ dateRangeProgress.total }}</span>
            </div>
            <p-tag [value]="dateRangeProgress?.status ?? 'INICIANDO'" [severity]="dateRangeProgress?.status === 'COMPLETED' ? 'success' : dateRangeProgress?.status === 'FAILED' ? 'danger' : 'info'"></p-tag>
          </div>
          <p-progressBar [value]="dateRangePercentage" [showValue]="true" unit="%" [mode]="dateRangeProgressMode" [style]="{ height: '20px' }"></p-progressBar>
          <div *ngIf="dateRangeProgress" class="progress-details mt-2">
            <div class="detail-item"><span class="detail-label">Faixa</span><span class="detail-value">ID {{ dateRangeProgress.idInicial }} – {{ dateRangeProgress.idFinal }}</span></div>
            <div class="detail-item"><span class="detail-label">Salvos</span><span class="detail-value">{{ dateRangeProgress.savedCount }} registro(s)</span></div>
            <div class="detail-item" *ngIf="dateRangeProgress.message"><span class="detail-label">Última mensagem</span><span class="detail-value">{{ dateRangeProgress.message }}</span></div>
          </div>
        </div>
      </ng-template>
    </p-card>
  `,
  styles: [`
    .import-form {
      padding: 0.5rem 0;
    }

    .form-row {
      display: flex;
      align-items: flex-end;
      gap: 1.5rem;
      flex-wrap: wrap;
    }

    .field {
      display: flex;
      flex-direction: column;
      gap: 0.35rem;
      min-width: 180px;
    }

    .field label {
      font-weight: 600;
      font-size: 0.875rem;
      color: var(--text-color-secondary, #64748b);
    }

    .field-action {
      padding-bottom: 2px;
    }

    .progress-section {
      background: var(--surface-ground, #f8f9fa);
      border-radius: 8px;
      padding: 1rem;
    }

    .progress-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.75rem;
    }

    .progress-info {
      display: flex;
      flex-direction: column;
      gap: 0.15rem;
    }

    .progress-label {
      font-weight: 700;
      font-size: 1rem;
    }

    .progress-sub {
      font-size: 0.85rem;
      color: var(--text-color-secondary, #64748b);
    }

    .progress-details {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 0.75rem;
      padding-top: 0.5rem;
    }

    .detail-item {
      display: flex;
      flex-direction: column;
      gap: 0.15rem;
    }

    .detail-label {
      font-size: 0.75rem;
      font-weight: 600;
      color: var(--text-color-secondary, #64748b);
      text-transform: uppercase;
    }

    .detail-value {
      font-size: 0.9rem;
      font-weight: 500;
    }

    .error-list {
      background: #fff3f3;
      border: 1px solid #fecaca;
      border-radius: 6px;
      padding: 0.75rem 1rem;
    }

    .error-list h4 {
      margin: 0 0 0.5rem 0;
      color: #dc2626;
      font-size: 0.95rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .error-list ul {
      margin: 0;
      padding-left: 1.25rem;
      font-size: 0.875rem;
      color: #991b1b;
    }

    .error-list li {
      margin-bottom: 0.25rem;
      word-break: break-all;
    }

    .result-card {
      background: var(--surface-ground, #f8f9fa);
      border-radius: 8px;
      padding: 1rem;
    }

    .result-card h3 {
      margin: 0 0 1rem 0;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: var(--green-600, #16a34a);
    }

    .result-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      gap: 1rem;
    }

    .result-field {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }

    .result-field label {
      font-size: 0.8rem;
      font-weight: 600;
      color: var(--text-color-secondary, #64748b);
      text-transform: uppercase;
    }

    .result-field span {
      font-size: 0.95rem;
    }

    .result-field-full {
      grid-column: 1 / -1;
    }

    .no-result {
      margin-top: 1rem;
    }

    .empty-state {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 1.5rem;
      color: var(--text-color-secondary, #64748b);
      font-size: 1rem;
      background: var(--surface-ground, #f8f9fa);
      border-radius: 8px;
    }

    .empty-state i {
      font-size: 1.5rem;
    }

    .empty-state p {
      margin: 0;
    }

    .mt-3 { margin-top: 1.5rem; }
    .mt-4 { margin-top: 2rem; }

    :host ::ng-deep .p-card .p-card-content {
      padding: 0;
    }

    :host ::ng-deep .p-toolbar {
      border: none;
      padding: 1rem 0;
    }

    .w-full {
      width: 100%;
    }
  `]
})
export class ComplaintImportComponent implements OnDestroy {

  // ─── Estado: Importação por faixa de IDs ───
  idRange = { idInicial: null as number | null, idFinal: null as number | null };

  running = {
    byRange: false,
    byDate: false,
  };

  rangeProgress: ProgressEventDTO | null = null;
  rangePercentage = 0;
  rangeProgressMode: 'determinate' | 'indeterminate' = 'determinate';
  rangeResult: ManualExecutionResponse | null = null;

  // ─── Estado: Consulta por data ───
  dateSearch = { date: '' };
  dateImportRunning = false;
  dateResult: ComplaintResponseDTO | null = null;
  dateNotFound = false;
  dateProgress: ProgressEventDTO | null = null;
  datePercentage = 0;
  dateProgressMode: 'determinate' | 'indeterminate' = 'determinate';

  // ─── Estado: Importação por intervalo de datas ───
  dateRangeStart = '';
  dateRangeEnd = '';
  dateRangeRunning = false;
  dateRangeProgress: ProgressEventDTO | null = null;
  dateRangePercentage = 0;
  dateRangeProgressMode: 'determinate' | 'indeterminate' = 'determinate';
  dateRangeResult: ManualExecutionResponse | null = null;

  private rangeSubscription: Subscription | null = null;
  private dateSubscription: Subscription | null = null;
  private dateRangeSubscription: Subscription | null = null;

  constructor(
    private complaintApiService: ComplaintApiService,
    private messageService: MessageService,
  ) {}

  ngOnDestroy(): void {
    this.cancelRangeImport();
    this.cancelDateImport();
    this.cancelDateRangeImport();
  }

  // ──────────────────────────────────────────────
  //  Importação por faixa de IDs (SSE)
  // ──────────────────────────────────────────────

  canStartRange(): boolean {
    const { idInicial, idFinal } = this.idRange;
    return idInicial != null && idFinal != null && idInicial > 0 && idFinal > 0;
  }

  startRangeImport(): void {
    const { idInicial, idFinal } = this.idRange;
    if (idInicial == null || idFinal == null || !this.canStartRange()) return;

    // Reseta estado
    this.resetRangeState();
    this.running.byRange = true;
    this.rangeProgressMode = 'indeterminate';

    this.complaintApiService.executeManualFetch(idInicial, idFinal).subscribe({
      next: (res) => {
        if (res.success) {
          this.rangeResult = res;
          this.messageService.add({
            severity: 'info',
            summary: 'Importação iniciada',
            detail: res.message,
          });
          this.watchProgress(res.executionId);
        } else {
          this.running.byRange = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Falha',
            detail: res.message,
          });
        }
      },
      error: (err) => {
        this.running.byRange = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro de conexão',
          detail: err?.error?.message || err.message || 'Não foi possível iniciar a importação.',
        });
      },
    });
  }

  private watchProgress(executionId: string): void {
    this.rangeSubscription = this.complaintApiService.streamProgress(executionId).subscribe({
      next: (event) => {
        this.rangeProgress = event;
        this.rangeProgressMode = 'determinate';
        this.rangePercentage = event.percentComplete;

        if (event.status === 'COMPLETED') {
          this.rangePercentage = 100;
          this.running.byRange = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Importação concluída',
            detail: `${event.savedCount} de ${event.total} denúncias salvas com sucesso.`,
          });
        } else if (event.status === 'FAILED') {
          this.running.byRange = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Importação falhou',
            detail: event.message || 'Erro desconhecido no processamento.',
          });
        }
      },
      error: () => {
        this.running.byRange = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Conexão SSE perdida. O servidor pode ter encerrado o stream.',
        });
      },
    });
  }

  cancelRangeImport(): void {
    this.rangeSubscription?.unsubscribe();
    this.rangeSubscription = null;
    this.running.byRange = false;
  }

  private resetRangeState(): void {
    this.cancelRangeImport();
    this.rangeProgress = null;
    this.rangePercentage = 0;
    this.rangeProgressMode = 'determinate';
    this.rangeResult = null;
  }

  // ──────────────────────────────────────────────
  //  Importação por Data Única — com progresso
  // ──────────────────────────────────────────────

  startDateImport(): void {
    const date = this.dateSearch.date.trim();
    if (!date) return;

    this.dateImportRunning = true;
    this.dateResult = null;
    this.dateNotFound = false;
    this.dateProgress = null;
    this.datePercentage = 0;
    this.dateProgressMode = 'indeterminate';

    this.complaintApiService.executeManualByDate(date).subscribe({
      next: (res) => {
        if (!res.success) {
          this.dateImportRunning = false;
          this.messageService.add({ severity: 'error', summary: 'Falha', detail: res.message });
          return;
        }
        this.messageService.add({ severity: 'info', summary: 'Iniciado', detail: res.message });
        this.watchDateProgress(res.executionId);
      },
      error: (err) => {
        this.dateImportRunning = false;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: err?.error?.message || err.message });
      },
    });
  }

  private watchDateProgress(executionId: string): void {
    this.dateSubscription = this.complaintApiService.streamProgress(executionId).subscribe({
      next: (ev) => {
        this.dateProgress = ev;
        this.dateProgressMode = 'determinate';
        this.datePercentage = ev.percentComplete;
        if (ev.status === 'COMPLETED') {
          this.datePercentage = 100;
          this.dateImportRunning = false;
          this.messageService.add({ severity: 'success', summary: 'Concluído', detail: `${ev.savedCount} de ${ev.total} salvos.` });
        } else if (ev.status === 'FAILED') {
          this.dateImportRunning = false;
          this.messageService.add({ severity: 'error', summary: 'Falhou', detail: ev.message });
        }
      },
      error: () => { this.dateImportRunning = false; },
    });
  }

  cancelDateImport(): void {
    this.dateSubscription?.unsubscribe();
    this.dateSubscription = null;
    this.dateImportRunning = false;
  }

  // ──────────────────────────────────────────────
  //  Importação por Intervalo de Datas
  // ──────────────────────────────────────────────

  canStartDateRange(): boolean {
    return !!this.dateRangeStart && !!this.dateRangeEnd;
  }

  startDateRangeImport(): void {
    if (!this.dateRangeStart || !this.dateRangeEnd) return;

    this.dateRangeRunning = true;
    this.dateRangeProgress = null;
    this.dateRangePercentage = 0;
    this.dateRangeProgressMode = 'indeterminate';
    this.dateRangeResult = null;

    this.complaintApiService.executeManualByDateRange(this.dateRangeStart, this.dateRangeEnd).subscribe({
      next: (res) => {
        if (!res.success) {
          this.dateRangeRunning = false;
          this.messageService.add({ severity: 'error', summary: 'Falha', detail: res.message });
          return;
        }
        this.dateRangeResult = res;
        this.messageService.add({ severity: 'info', summary: 'Iniciado', detail: res.message });
        this.watchDateRangeProgress(res.executionId);
      },
      error: (err) => {
        this.dateRangeRunning = false;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: err?.error?.message || err.message });
      },
    });
  }

  private watchDateRangeProgress(executionId: string): void {
    this.dateRangeSubscription = this.complaintApiService.streamProgress(executionId).subscribe({
      next: (ev) => {
        this.dateRangeProgress = ev;
        this.dateRangeProgressMode = 'determinate';
        this.dateRangePercentage = ev.percentComplete;
        if (ev.status === 'COMPLETED') {
          this.dateRangePercentage = 100;
          this.dateRangeRunning = false;
          this.messageService.add({ severity: 'success', summary: 'Concluído', detail: `${ev.savedCount} de ${ev.total} salvos.` });
        } else if (ev.status === 'FAILED') {
          this.dateRangeRunning = false;
          this.messageService.add({ severity: 'error', summary: 'Falhou', detail: ev.message });
        }
      },
      error: () => { this.dateRangeRunning = false; },
    });
  }

  cancelDateRangeImport(): void {
    this.dateRangeSubscription?.unsubscribe();
    this.dateRangeSubscription = null;
    this.dateRangeRunning = false;
  }

  // ─── Labels derivados para o progresso ───

  get rangeStatusLabel(): string {
    if (!this.rangeProgress) return 'Enviando requisição...';
    if (this.rangeProgress.status === 'PROCESSING') return 'Processando denúncias...';
    if (this.rangeProgress.status === 'COMPLETED') return 'Importação finalizada!';
    if (this.rangeProgress.status === 'FAILED') return 'Importação interrompida.';
    return '';
  }

  get rangeTagLabel(): string {
    if (!this.rangeProgress) return 'INICIANDO';
    return this.rangeProgress.status;
  }

  get rangeTagSeverity(): 'info' | 'success' | 'danger' | 'warn' | 'secondary' | 'contrast' {
    if (!this.rangeProgress) return 'info';
    switch (this.rangeProgress.status) {
      case 'PROCESSING': return 'info';
      case 'COMPLETED': return 'success';
      case 'FAILED': return 'danger';
    }
  }

  // ──────────────────────────────────────────────
  //  Consulta por Data (simples)
  // ──────────────────────────────────────────────

  canSearchDate(): boolean {
    return this.dateSearch.date.trim().length > 0;
  }

  searchByDate(): void {
    const date = this.dateSearch.date.trim();
    if (!date) return;

    this.running.byDate = true;
    this.dateResult = null;
    this.dateNotFound = false;

    this.complaintApiService.getComplaintByDate(date).subscribe({
      next: (data) => {
        this.dateResult = data;
        this.dateNotFound = false;
        this.running.byDate = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Denúncia encontrada',
          detail: `ID: ${data.id} — ${data.registerDate}`,
        });
      },
      error: (err) => {
        this.running.byDate = false;
        if (err.status === 404) {
          this.dateNotFound = true;
          this.dateResult = null;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro na consulta',
            detail: err?.error?.message || err.message || 'Não foi possível consultar a data.',
          });
        }
      },
    });
  }
}
